// extracted by mini-css-extract-plugin
export default {"collapsed":"Title_collapsed__G5fi8"};